export default "__VITE_ASSET__Dp0ZQY1P__"